import React from 'react'
import {
  HeadingText,
  BodyText,
  WarningIcon,
  Button,
} from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'
import { FullScreenError as FullScreenErrorProps } from '../../../typings'
import { getContentStyles } from '../../utils/styles/contentStyle'
import {
  errorContainerStyle,
  errorTextStyle,
  btnsStyles,
  errorButtonContainerStyle,
} from '../groupdetail/index.css'

const FullScreenError = (props: FullScreenErrorProps) => {
  const { title, description, action } = props
  return (
    <div className={getContentStyles()} data-testid="error-page">
      <div className={errorContainerStyle}>
        <WarningIcon size="xl" color="sysColorWarningMain" />
        <HeadingText size="sm" as="h1" className={errorTextStyle}>
          <Message id={title} />
        </HeadingText>
        {description && (
          <BodyText
            as="p"
            className={errorTextStyle}
            data-testid="error-description"
          >
            <Message id={description} />
          </BodyText>
        )}

        {action && action.title && action.href && (
          <div className={errorButtonContainerStyle}>
            <Button
              as="a"
              className={btnsStyles}
              href={action.href}
              role="button"
              data-testid="error-action"
            >
              <Message id={action.title} />
            </Button>
          </div>
        )}
      </div>
    </div>
  )
}

export default FullScreenError
